import React from 'react';
import PropTypes from 'prop-types';


const AllPartsDocument = ({
  allPartsCount,
  onDownloadZipClick,
  onDownloadComboPdfClick,
  onDownloadEmailZipClick,
  onEmailCombinedPdf,
  onAllPartsPrintPreview,
}) => (
  <tr className="all-parts-document bulk-operations odd no-filter-search" key="all-parts">
    <td />
    <td />
    <td>All parts</td>
    <td>{ allPartsCount }</td>
    <td className="bulk-operations">
      <div className=" menu">
        <div className="ui delayed dropdown item">
          <span className="download icon" /> &nbsp;
          <span className="email icon" /> &nbsp;
          <span className="preview icon" /> ...
          <div className="menu" style={{ display: 'block' }}>
            <div className="item" onClick={onDownloadZipClick}><span
              className="download icon" />
              <span className="zip icon right" /> Download ZIP
            </div>
            <div className="item" onClick={onDownloadComboPdfClick}>
              <span className="download icon" />
              <span className="pdf icon right" />
              Download Combined PDF &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div className="item" onClick={onDownloadEmailZipClick}>
              <span className="email icon" />
              <span className="zip icon right" /> Email ZIP
            </div>
            <div className="item" onClick={onEmailCombinedPdf}>
              <span className="email icon" />
              <span className="pdf icon right" /> Email Combined PDF
            </div>
            <div className="item" onClick={onAllPartsPrintPreview}>
              <span className="preview icon" /> Print Preview
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
);

AllPartsDocument.propTypes = {
  allPartsCount: PropTypes.number.isRequired,
  onDownloadZipClick: PropTypes.func.isRequired,
  onDownloadComboPdfClick: PropTypes.func.isRequired,
  onDownloadEmailZipClick: PropTypes.func.isRequired,
  onEmailCombinedPdf: PropTypes.func.isRequired,
  onAllPartsPrintPreview: PropTypes.func.isRequired,
};

export default AllPartsDocument;



// WEBPACK FOOTER //
// ./src/components/case/claims/claimsEntries/AllPartsDocument.jsx